<template>
  <v-app id="washwerk">
    <app-messages />
    <conduct-maintenance-toolbar />
    <conduct-maintenance-navigation />
    <v-main>
      <slot />
    </v-main>
    <update-dialog />
  </v-app>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import ConductMaintenanceNavigation from '@/components/ConductMaintenanceNavigation.vue'
import ConductMaintenanceToolbar from '@/components/ConductMaintenanceToolbar.vue'
import AppMessages from '@/components/AppMessages.vue'
import UpdateDialog from '@/components/UpdateDialog.vue'

export default defineComponent({
  components: {
    UpdateDialog,
    ConductMaintenanceNavigation,
    ConductMaintenanceToolbar,
    AppMessages,
  },
})
</script>

<style scoped></style>
